import React from "react";
//import swal from "sweetalert";
//import firebase from "firebase/app";
//import { dbApp } from "../../../firebase/config";

const ListadoProductos = ({ productos, eliminarProducto }) => {
  //<FiltroBusqueda />

  /*var desertRef = firebase.storage().refFromURL(url);
    console.log(desertRef);*/

  // Delete the file
  /*desertRef
      .delete()
      .then(function() {
        console.log("Bien");
      })
      .catch(function(error) {
        console.log("error");
      });*/

  /*swal({
      title: "Eliminar Producto!",
      text: "¿Estás seguro de eliminar el producto?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        swal("Producto eliminado correctamente!", {
          icon: "success"
        });
      }
    });*/

  return (
    <>
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col texto-centrado">Nombre</th>
            <th scope="col d-flex justify-content-end">Opciones</th>
          </tr>
        </thead>
        <tbody>
          {productos.map(producto => (
            <tr key={producto.id}>
              <td>{producto.nombre}</td>
              <td className="d-flex justify-content-end">
                <i
                  className="fa fa-pencil-square-o text-primary fa-lg m-2 cursor-pointer"
                  aria-hidden="true"
                ></i>
                <i
                  className="fa fa-trash-o text-danger fa-lg m-2 cursor-pointer"
                  aria-hidden="true"
                  onClick={() => eliminarProducto(producto)}
                ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

/*function FiltroBusqueda() {
  return <h1>Filtro de bsuqueda</h1>;
}*/

export default ListadoProductos;
